/** A-Block shared formatters for the holding-first client UI. */

/** Compact UAH, e.g. 1234567 → "1,23 млн ₴"; null → "—". */
export function uah(v: number | null | undefined): string {
  if (v == null) return "—";
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2).replace(".", ",")} млн ₴`;
  if (abs >= 1_000) return `${Math.round(v / 1000).toLocaleString("uk-UA")} тис ₴`;
  return `${Math.round(v).toLocaleString("uk-UA")} ₴`;
}

/** Plain grouped number; null/0 → "—". */
export function num(v: number | null | undefined): string {
  if (v == null || v === 0) return "—";
  return Math.round(v).toLocaleString("uk-UA");
}

/** Relative-ish date label from ISO/Y-m-d; null → "—". */
export function lastOrderLabel(v: string | null | undefined): string {
  if (!v) return "—";
  const d = new Date(v.length <= 10 ? v + "T00:00:00" : v);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("uk-UA", { day: "numeric", month: "short" });
}

export const RISK_LABEL: Record<string, string> = {
  red: "Високий",
  yellow: "Середній",
  green: "Низький",
};

/** Risk dot color (Tailwind class on bg). */
export const RISK_DOT: Record<string, string> = {
  red: "bg-destructive",
  yellow: "bg-warning-foreground",
  green: "bg-success-foreground",
};

export const ABC_BADGE: Record<string, string> = {
  A: "bg-success text-success-foreground",
  B: "bg-warning text-warning-foreground",
  C: "bg-muted text-muted-foreground",
};
